import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { IssueEntity } from './issue.entity';

@Index('issue_status_history__fk_issue__id_fk', ['fkIssueId'], {})
@Entity('issue_status_history')
export class IssueStatusHistoryEntity extends BaseEntity {
	@Column('int', { name: '_fk_issue__id', unsigned: true })
	public fkIssueId!: number;

	@Column('varchar', { name: 'old_status', length: 64, nullable: true })
	public oldStatus!: string | null;

	@Column('varchar', { name: 'new_status', length: 64 })
	public newStatus!: string;

	@Column('datetime', { name: 'changed_at' })
	public changedAt!: Date;

	@ManyToOne(() => IssueEntity, (issue) => issue.statusHistory, {
		onDelete: 'CASCADE',
		onUpdate: 'CASCADE',
	})
	@JoinColumn([{ name: '_fk_issue__id', referencedColumnName: 'id' }])
	public fkIssue!: IssueEntity;
}
